// Angular
import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../../../services/app.service';
import { Observable, of as observableOf, BehaviorSubject, pipe } from 'rxjs';
import { SystemNotificationItem } from '../../../../../models/system-notification-item';
import { SystemAlert } from '../../../../../models/system-alert.table';
import { Router } from '@angular/router';
import { StringFormatPipe } from '../../../../../core/_base/layout/pipes/string-format.pipe';
import { ISystemAlertMappingItem } from '../../../../../contracts/ISystemAlertMappingItem';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../../core/auth/_services/auth.service';

const notificationRouting: ISystemAlertMappingItem[] = [
	{
		alertId: SystemAlert.EvaluationSentForApprovement,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.EVALUATION_SENT_FOR_APPROVEMENT',
		route: '/evaluations/approvement-review/{0}',
		queryParams: null
		
	},
	{
		alertId: SystemAlert.NewQuestionnaireAvailable,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.NEW_QUESTIONNAIRE_AVAILABLE',
		route: '/thirdparties/evaluation/reply-questionnaire/{0}',
		queryParams: null
	},
	{
		alertId: SystemAlert.QuestionnaireReviewRequired,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.QUESTIONNAIRE_REVIEW_REQUIRED',
		route: '/thirdparties/evaluation/reply-questionnaire/{0}',
		queryParams: null
	},
	{
		alertId: SystemAlert.NewDueDiligenceRequestAvailable,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.NEW_DUEDILIGENCE_REQUEST_AVAILABLE',
		route: '/due-diligence/request-form/{0}',
		queryParams: { readOnlyMode: true }
	},
	{
		alertId: SystemAlert.ThirdpartyQuestionnaireAnswred,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.THIRDPARTY_QUESTIONNAIRE_ANSWRED',
		route: '/thirdparties/evaluation/continue/{0}',
		queryParams: null
	},
	{
		alertId: SystemAlert.DueDiligenceCompletedNoEvaluation,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.DUEDILIGENCE_COMPLETED',
		route: '/thirdparties/view-due-diligence/{0}', // actualizar ruta luego del merge!!!
		queryParams: null
	},
	{
		alertId: SystemAlert.DueDiligenceCompletedWithEvaluation,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.DUEDILIGENCE_COMPLETED',
		route: '/thirdparties/evaluation/continue/{0}', 
		queryParams: null
	},
	{
		alertId: SystemAlert.EvaluationAvailableToContinue,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.EVALUATION_AVAILABLE_TO_CONTINUE',
		route: '/thirdparties/evaluation/continue/{0}', 
		queryParams: null
	},
	{
		alertId: SystemAlert.EvaluationApprovementRequestProcessed,
		message: 'SYSTEM.NOTIFICATIONS.MESSAGES.EVALUATION_APPROVEMENT_REQUEST_PROCESSED',
		route: '/thirdparties/detail/{0}', 
		queryParams: null
	}
];


@Component({
	selector: 'kt-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['notification.component.scss']
})
export class NotificationComponent implements OnInit, AfterViewInit {	
	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon: string = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';

	_notifications$: BehaviorSubject<SystemNotificationItem[]>;	
	get notifications(): SystemNotificationItem[] {
		return this._notifications$.getValue();
	}	
	set notifications(value : SystemNotificationItem[]) {
		this._notifications$.next(value);
	}

	newNotificationCount: number = 0;

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(
		private sanitizer: DomSanitizer,
		private _appService: AppService,
		private router: Router,
		private stringFormat: StringFormatPipe,
		private translate: TranslateService,
		private _auth: AuthService
	) {
		this._notifications$ = new BehaviorSubject<SystemNotificationItem[]>([]);
	}

	ngOnInit(): void {
		this.getNotifications();
		
		// Counting new messages on notification arrived
		this._notifications$.subscribe(res => {
			this.countNewNotifications(res);
		})
	}

	ngAfterViewInit(): void {
		this.scheduleNotificationRefresh();
	}
	
	private countNewNotifications(notifications: SystemNotificationItem[]) {
		this.newNotificationCount = notifications.filter(x => !x.isRead).length;
	}

	private getNotifications() {
		// Getting System Notifications and filling Item with custom data
		this._appService.getSystemNotification()
		// .pipe(
		// 	map( res => {
		// 		res.forEach(x => {
		// 		 const routingItem = this.getNotificationRoutingItem(x);
		// 		 x = Object.assign(x, routingItem) as SystemNotificationItem;
		// 		 //Adding translation
		// 		 x.message = this.translate.instant(x.message);
		// 		 // Adding parameters for message
		// 		 x.message = this.stringFormat.transform(x.message, ... x.messageParams)
		// 		 // Merging referenceId into route
		// 		 x.route = this.stringFormat.transform(x.route, x.referenceId);
		// 		});
		// 		return res;
		// 	})
		// )
		.subscribe(res => {
			this.notifications = res.map( x => {
				var msg: string;				
				msg = x.message.replace('<b>Triage</b>', `<b>${this.translate.instant('DATA.THIRDPARTY_EVALUATION.STAGE.TRIAGE')}</b>`);
				msg = msg.replace('<b>RequestForm</b>', `<b>${this.translate.instant('DATA.THIRDPARTY_EVALUATION.STAGE.REQUESTFORM')}</b>`);
				msg = msg.replace('<b>ThirdParty</b>', `<b>${this.translate.instant('DATA.THIRDPARTY_EVALUATION.STAGE.THIRDPARTY')}</b>`);
				msg = msg.replace('<b>RedFlag</b>', `<b>${this.translate.instant('DATA.THIRDPARTY_EVALUATION.STAGE.REDFLAG')}</b>`);
				msg = msg.replace('<b>DueDiligence</b>', `<b>${this.translate.instant('DATA.THIRDPARTY_EVALUATION.STAGE.DUEDILIGENCE')}</b>`);
				x.message = msg;

				return x;
			});
		});
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}

	getNotificationRoutingItem(item: SystemNotificationItem): ISystemAlertMappingItem {
		const routingItem = notificationRouting.filter(x => x.alertId == item.alertId)[0];
		return routingItem;
	}

	redirectToScreen(item: SystemNotificationItem): void {
		if (!item.isRead) {
			this._appService.notifySystemAlert(item).subscribe(res => {
				item.isRead = res;
				this.countNewNotifications(this.notifications);
				this.router.navigate([item.route]);
			})
		}
	}

	scheduleNotificationRefresh(): void {
		setInterval(() => this.getNotifications() , this._auth.notificationRefreshTime*10000)
	}


}
